import "./style.css";

const HeaderReport = (props) => {
	return (
		<header className="header-report">
			<span className="title">{props.title}</span>
			<span className="sub-title">{props.subTitle}</span>
		</header>
	);
};

export default HeaderReport;
